import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-1 small"
}
const _hoisted_2 = {
  key: "clock",
  class: "mb-0"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: "timer",
  class: "mb-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, " za ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'd-inline': !!_ctx.inline })
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_2, [
      (_ctx.inline)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " o "))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.formattedMoonTime), 1)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _hoisted_5,
      _createTextVNode(" " + _toDisplayString(_ctx.timeToMoonEvent), 1)
    ])
  ], 2))
}